import { render, staticRenderFns } from "./user_jf.vue?vue&type=template&id=bdb88aca&scoped=true"
import script from "./user_jf.vue?vue&type=script&lang=js"
export * from "./user_jf.vue?vue&type=script&lang=js"
import style0 from "./user_jf.vue?vue&type=style&index=0&id=bdb88aca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb88aca",
  null
  
)

export default component.exports